import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  border-radius: 8px;
  background-color: #e5e7eb;
  gap: 8px;
`

export const Panel: React.FC<{ children; className?: string }> = ({
  children,
  className = "",
}) => {
  return <Container className={className}>{children}</Container>
}
